<template>
  <div class="">
    <!-- 搜索及筛选 -->
    <div class="whiteBg main-top">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px">
        <el-form-item label="试题分类：" prop="categoryId">
          <el-cascader v-model="ruleForm.categoryId" :options="sortList" :props="{ expandTrigger: 'hover', emitPath: false, checkStrictly: true }"></el-cascader>
        </el-form-item>
        <el-form-item label="试题难度：">
          <el-select v-model="ruleForm.difficulty" placeholder="请选择试题难度">
            <el-option v-for="item in diffOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="题干：" prop="stem">
          <el-input v-model="ruleForm.stem" style="width: 80%" placeholder="题干，点击编辑"></el-input>
        </el-form-item>
        <el-form-item label="选项：" class="mt12" required>
          <div v-for="(item, index) in options" :key="index" style="margin-bottom: 10px">
            <el-checkbox v-model="item.isCorrect" :label="index">{{ String.fromCharCode(65 + index) }}.</el-checkbox>
            <el-input v-model="item.optionName" style="width: 75%; margin-left: 20px" placeholder="选项，点此编辑；选中即设置为正确答案"></el-input>
            <el-button type="text" @click="delOptions(index)" icon="el-icon-delete" style="margin-left: 10px"></el-button>
            <el-button type="text" @click="changeReqIndex(index, 'down')" :disabled="index + 1 === options.length" icon="el-icon-bottom"></el-button>
            <el-button type="text" @click="changeReqIndex(index, 'up')" :disabled="index === 0" icon="el-icon-top"></el-button>
          </div>
          <el-button type="text" @click="addOptions" icon="el-icon-plus">添加选项</el-button>
        </el-form-item>
        <el-form-item label="解析：">
          <wang-editor
            style="width: 80%"
            :mainBody="ruleForm.analysis"
            @onChange="
              (str) => {
                ruleForm.analysis = str;
              }
            "
          ></wang-editor>
        </el-form-item>
        <el-form-item label="试题标签：" required>
          <el-tag v-for="(item, index) in labelNameList" style="margin-right: 10px" :key="index">{{ item.name }}</el-tag>
          <el-button type="primary" plain icon="el-icon-plus" style="margin-left: 10px" @click="addTabs">添加标签</el-button>
        </el-form-item>
        <div class="box box-align-center box-pack-end mt-btns mt24" style="margin-right: 30px">
          <el-button type="primary" plain @click="submitForm('ruleForm')">录入</el-button>
          <el-button plain @click="resetForm">重置</el-button>
        </div>
      </el-form>
    </div>
    <el-dialog title="添加标签" :visible.sync="tabsVisible" width="60%">
      <el-form>
        <el-row>
          <el-col :span="8">
            <el-form-item label="标签名称：">
              <el-input v-model="labelName" style="width: 200px" placeholder="请输入标签名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="创建时间：">
              <el-date-picker
                v-model="labelTime"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <div class="">
              <el-button type="primary" @click="search()"> <i class="el-icon-search" style="margin-right: 5px"></i>查询 </el-button>
              <el-button @click="search('refresh')"> <i class="el-icon-refresh" style="margin-right: 5px"></i>重置 </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <el-divider></el-divider>
      <div class="boxFlex">
        <!-- <el-checkbox-group v-for="(item, index) in labelList" :key="index" v-model="checkList" @change="changeTabs">
          <el-checkbox class="boxStyle" :label="item" border>{{ item.name }}</el-checkbox>
        </el-checkbox-group> -->
        <dyTable
          :columns="columns"
          style="margin-top: 12px"
          :table-data="tableData"
          :total="total"
          ref="multipleTable"
          :page-num="pageNo"
          :page-size="10"
          element-loading-text="加载中"
          @current-change="pageChange"
          @selection-change="onSelectionChange"
        >
        </dyTable>
      </div>
      <div class="box box-align-center box-pack-end mt-btns mt24" style="margin-right: 30px">
        <el-button type="primary" plain @click="saveTabs">保存</el-button>
        <el-button type="danger" plain @click="() => (tabsVisible = false)">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import DyTable from '@/components/common/dytable';
import host from '@/api/index';
import { zgsourceAllCategory, deleteQuestion, detailQuestion, list4Select, listQuestion, saveQuestion, examineCourse, publishCourse, selectDelList } from '@/api/index';
import { getQuestionLabelList } from '@/api/index2';
import { encrypt, decrypt } from '@/api/common_encrypt';
import { pushUserType, operatingSystemPhone, statusList, channelType, jumpType, buttonType, resourcesList, delList } from '@/utils/commonData';
import { subtractArrays, uniqueBy, cleanObject, formatDate } from '@/utils/utils';
import wangEditor from '@/components/common/wangEditor/index';
var that = null;
export default {
  components: {
    DyTable,
    wangEditor,
  },
  data() {
    const { delArticle } = this;
    const { editArticle } = this;
    return {
      isChange: false,
      tableData: [],
      tabsList: [],
      searchForm: {},
      pageNo: 1,
      pageSize: 10,
      columns: [
        {
          type: 'selection',
          width: '55',
        },
        {
          type: 'index',
          width: 60,
          title: '序号',
        },
        {
          key: 'name',
          title: '标签名称',
        },
        {
          key: 'bgUserName',
          title: '操作人',
        },
        {
          key: 'operatetime',
          title: '最后更新时间',
          render: ({ row }) => {
            return <div>{formatDate(new Date(row.operatetime), 'yyyy-MM-dd hh:mm:ss')}</div>;
          },
        },
      ],
      checked1: '',
      labelName: '',
      labelTime: '',
      sortList: [],
      checkList: [],
      labelOptions: [],
      labelNameList: [],
      diffOptions: [
        { label: '简单', value: 1 },
        { label: '普通', value: 2 },
        { label: '困难', value: 3 },
      ],
      fbTableLoading: false,
      dialogVisible: false,
      pushUserType,
      statusList,
      channelType,
      jumpType,
      buttonType,
      operatingSystemPhone,
      activeName: '0',
      fbCurrentPage: 1,
      tableLoading: false,
      isCorrect: '',
      picUrl: '',
      topicId: '',
      categoryId: '',
      stem: '',
      spreadSpaceName: '',
      dialogTitle: '添加试题',
      shTableData: [],
      fbTableData: [],
      labelList: [],
      options: [{}, {}],
      resourcesList,
      restoreForm: { delTime: 3 },
      delList,
      fileList: [],
      tableData: [],
      total: 0,
      shTotal: 0,
      fbTotal: 0,
      currentPage: 1,
      pageSize: 10,
      ruleForm: {
        topicType: 2,
        difficulty: 2,
        isSchoolVisible: 0,
      },
      rules: {
        categoryId: [{ required: true, message: '请选择试题资源分类', trigger: 'change' }],
        stem: [{ required: true, message: '请输入题干', trigger: 'blur' }],
      },
      addVisible: false,
      resetVisible: false,
      tabsVisible: false,
      value: '',
      status: null,
      buttonTypeVal: '',
    };
  },
  mounted() {
    that = this;
    // that.getList();
    that.getLiveCategory();
    if (this.$route.query.id) {
      that.detailArticle(this.$route.query.id);
    }
  },
  computed: {
    uploadImg() {
      console.log('host', host);
      return host.uploadImgUrl;
    },
    headers() {
      return {
        'bg-token': localStorage.getItem('token'), // 直接从本地获取token就行
      };
    },
  },
  methods: {
    getList() {
      let param = {
        page: this.pageNo,
        pageSize: this.pageSize,
        ...this.searchForm,
      };
      console.log('123', param);
      getQuestionLabelList(cleanObject(param)).then((res) => {
        console.log('res', res);
        if (res.result == 1) {
          this.tableData = res.data.list;
          this.total = res.data.total;
          that.setPage();
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          });
        }
      });
    },
    pageChange(val) {
      that.isChange = true;
      this.pageNo = val;
      console.log('val :>> ', val);
      this.getList();
    },
    onSelectionChange(val) {
      if (that.isChange || val.length == 0) {
        return;
      }
      that.delData = subtractArrays(that.tableData, val);
      let allArr = uniqueBy(that.tableData.concat(that.tabsList), 'id');
      that.tabsList = subtractArrays(allArr, that.delData);
      console.log('that.tabsList', that.tabsList);
      const labelList = that.tabsList.map((item) => {
        return item.id;
      });
      this.ruleForm.label = labelList;
    },
    setPage() {
      // 重新设置选中状态
      that.$nextTick(() => {
        let selList = [];
        console.log('当前选择数据', that.tabsList);
        that.$refs.multipleTable.$refs.ElTable.clearSelection();
        that.tabsList.forEach((item) => {
          const row = that.tableData.find((row) => row.id === item.id);
          if (row) {
            selList.push(row);
            that.$refs.multipleTable.$refs.ElTable.toggleRowSelection(row, true);
          }
        });
        that.delData = subtractArrays(that.tableData, selList);
        that.$nextTick(() => {
          that.isChange = false;
        });
      });
    },
    addOptions() {
      if (this.options.length > 7) {
        this.$message.warning('最多只能8个选项');
        return;
      }
      this.options.push({});
    },
    addTabs() {
      this.tabsVisible = true;
      this.checkList = [];
      this.getList();
    },
    delOptions(index) {
      if (this.options.length < 3) {
        this.$message.warning('选项至少保留两个');
        return;
      }
      this.options.splice(index, 1);
    },
    changeReqIndex(index, type) {
      let param = {};
      if (type === 'up') {
        param = {
          ...this.options[index - 1],
        };
        this.options[index - 1] = {
          ...this.options[index],
        };
        this.options[index] = param;
        // return;
      }
      if (type === 'down') {
        param = {
          ...this.options[index + 1],
        };
        this.options[index + 1] = {
          ...this.options[index],
        };
        this.options[index] = param;
      }
      this.options = [...this.options];
    },
    //按钮封面图
    handlePosterPreview(response, file, fileList) {
      that.ruleForm.fileName = file.name;
      that.ruleForm.fileUrl = file.response.data.url;
    },
    //重置列表
    resetList() {
      that.fbCurrentPage = 1;
      that.stem = null;
      that.categoryId = null;
      that.getList();
    },
    //编辑按钮
    detailArticle(id) {
      let info = {
        id,
      };
      console.log(info);
      var data = encrypt(JSON.stringify(info));
      detailQuestion(data).then((res) => {
        if (res.result == 1) {
          var ress = JSON.parse(decrypt(res.data));
          console.log('res', ress);
          that.dialogTitle = '编辑试题';
          that.ruleForm = {
            ...ress,
          };
          if (ress.answer) {
            const list = JSON.parse(ress.answer);
            if (list && list.length > 0) {
              that.options = list;
              const index = list.findIndex((item) => {
                return item.isCorrect;
              });
              that.isCorrect = index;
            }
          }
          const labelList = ress.labelName.split(',');
          const aa = [];
          labelList.forEach((item) => {
            const obj = {};
            obj.name = item;
            aa.push(obj);
          });
          that.labelNameList = aa;
          // that.ruleForm.label = ress.label;
          // that.labelOptions =
        } else {
          that.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          });
        }
      });
    },
    //删除按钮
    delArticle(id) {
      that
        .$confirm('确认要删除此项吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          let info = {
            id,
          };
          console.log(info);
          var data = encrypt(JSON.stringify(info));
          deleteQuestion(data).then((res) => {
            this.$message({
              showClose: true,
              message: '删除成功',
              type: 'success',
            });
            that.getList();
          });
        });
    },
    //获取所有直播分类(树型结构)
    getLiveCategory() {
      let info = {
        type: 2,
      };
      console.log(info);
      var data = encrypt(JSON.stringify(info));
      zgsourceAllCategory(data).then((res) => {
        if (res.result == 1) {
          var ress = JSON.parse(decrypt(res.data));
          console.log('获取所有直播分类', ress);
          that.sortList = that.listFor(ress);
        } else {
          that.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          });
        }
      });
    },
    listFor(arr) {
      let children = [];
      if (arr != null && arr != '' && arr != undefined) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].childCourseCategory != '' && arr[i].childCourseCategory != null && arr[i].childCourseCategory != undefined) {
            children.push({
              value: arr[i].id,
              label: arr[i].name,
              children: this.listFor(arr[i].childCourseCategory),
            });
          } else {
            children.push({
              value: arr[i].id,
              label: arr[i].name,
              children: this.listFor(arr[i].childCourseCategory),
            });
          }
        }
      } else {
        return;
      }
      return children;
    },
    search(type) {
      this.searchForm = {
        name: this.labelName,
        from: this.labelTime[0],
        to: this.labelTime[1],
      };
      this.currentPage = 1;
      if (type == 'refresh') {
        this.labelName = '';
        this.labelTime = '';
        this.searchForm = {};
      }
      this.getList();
    },
    saveTabs() {
      if (this.tabsList.length == 0) {
        this.$message.warning('请选择标签');
        return;
      }
      this.tabsVisible = false;
      this.labelNameList = this.tabsList;
    },
    changeRadio(index) {
      let list = [...that.options];
      console.log('list', list);
      list.forEach((item) => {
        item.isCorrect = false;
      });
      list[index].isCorrect = true;
      that.ruleForm.answer = JSON.stringify(list);
    },
    // 提交表单
    submitForm(formName) {
      that.$refs[formName].validate((valid) => {
        if (valid) {
          let list = [...that.options];
          console.log('list', list);
          const flagList = list.map((item) => {
            return Object.keys(item).includes('isCorrect');
          });
          if (flagList.indexOf(true) == -1) {
            this.$message.warning('请选择一个正确答案');
            return;
          }
          let flag = false;
          list.forEach((item) => {
            flag = !item.optionName;
          });
          if (flag) {
            this.$message.warning('请输入答案选项');
            return;
          }
          if (this.labelNameList.length == 0) {
            this.$message.warning('请上传试题标签');
            return;
          }
          // let list = [...that.options];
          // list[that.isCorrect].isCorrect = true;
          that.ruleForm.answer = JSON.stringify(list);
          // const labelList = that.labelOptions.map((item) => {
          //   return item.id;
          // });
          // that.ruleForm.label = labelList;
          var info = that.ruleForm;
          console.log('info====', info);
          var data = encrypt(JSON.stringify(info));
          saveQuestion(data).then((res) => {
            if (res.result == 1) {
              console.log(res);
              this.$message({
                showClose: true,
                message: '保存成功',
                type: 'success',
              });
              this.$router.push('./questionList');
            } else {
              this.$message({
                showClose: true,
                message: res.msg,
                type: 'error',
              });
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 重置
    resetForm() {
      this.ruleForm = {};
      this.options = [{}, {}];
      this.labelNameList = [];
    },
    onCurrentChangeFb(val) {
      that.fbCurrentPage = val;
      that.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/.el-tabs__item {
  min-width: 100px;
  text-align: center;
  padding: 0;
}

/deep/.el-dropdown {
  margin-right: 10px;
}

.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  display: block;
  white-space: nowrap;
}

// /deep/.el-tabs__header {
//     margin: 0;
// }
.main {
  padding-top: 0 !important;
  padding-right: 0 !important;
}

.main-top {
  padding: 20px 15px;
  border-bottom: 1px solid rgba(96, 98, 102, 0.2392);

  .mti-txt {
    white-space: nowrap;
  }
}

.main-middle {
  padding: 15px 11px;
}

.common-btns {
  padding: 0 22px 33px;
}
.boxFlex {
  display: flex;
  flex-wrap: wrap;
}
.boxStyle {
  // width: 23%;
  // height: 250px;
  margin: 10px;
}
</style>
